export default "__VITE_ASSET__DycVopvN__"